module.exports = __webpack_public_path__ + "img/VP-Standard-Assembly.da07ac27.jpg";